import { SITUATIONS, applySituation } from "@/lib/situations";

// "What should the Observer help with?" One box, with one-tap starting points for common situations.
// recent: [{ label, text }] from the person's own past meetings, so a focus they wrote once is one tap next time.
export const FocusField = ({ value, onChange, rows = 2, autoFocus = false, testid = "focus", recent = [] }) => (
  <div className="space-y-2">
    <textarea
      autoComplete="off"
      rows={rows}
      autoFocus={autoFocus}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      maxLength={1500}
      placeholder="What should the Observer help with? e.g. Help us settle the pricing disagreement without anyone feeling steamrolled."
      className="w-full resize-y bg-[var(--o-bg)] border border-[var(--o-border)] px-3 py-2.5 text-sm outline-none focus:border-[var(--o-fg)] transition-colors placeholder:text-[var(--o-muted3)]"
      data-testid={`${testid}-input`}
    />
    <div className="flex flex-wrap gap-1.5" data-testid={`${testid}-situations`}>
      {SITUATIONS.map(([label, text]) => {
        const on = (value || "").includes(text);
        return (
          <button
            key={label}
            type="button"
            onClick={() => onChange(applySituation(value, text))}
            aria-pressed={on}
            title={text}
            className={`px-2.5 py-1 text-xs border transition-colors ${on ? "border-[var(--o-fg)] text-[var(--o-fg)] bg-[var(--o-surface)]" : "border-[var(--o-border)] text-[var(--o-muted)] hover:text-[var(--o-fg)] hover:border-[var(--o-border-strong)]"}`}
            data-testid={`${testid}-situation`}
          >
            {label}
          </button>
        );
      })}
    </div>
    {recent.length > 0 && (
      <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testid}-recent`}>
        <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-[var(--o-muted3)] mr-1">From your meetings</span>
        {recent.map((r) => {
          const on = (value || "").trim() === r.text.trim();
          return (
            <button
              key={r.text}
              type="button"
              onClick={() => onChange(r.text)}
              aria-pressed={on}
              title={r.text}
              className={`max-w-[260px] truncate px-2.5 py-1 text-xs border transition-colors ${on ? "border-[var(--o-fg)] text-[var(--o-fg)] bg-[var(--o-surface)]" : "border-dashed border-[var(--o-border)] text-[var(--o-muted)] hover:text-[var(--o-fg)] hover:border-[var(--o-border-strong)]"}`}
              data-testid={`${testid}-recent-chip`}
            >
              {r.label}
            </button>
          );
        })}
      </div>
    )}
  </div>
);
